import Controller from '@ember/controller';

export default class JoinGroupController extends Controller {
  queryParams = ['email', 'inId', 'context'];
  email = null; // email that received invitation, used to prefill registration form
  inId = null; // invitation id
  context = null; // context needed for the event
}
